module.exports = __webpack_public_path__ + "img/LinkedIn_icon_circle.2ce9c7e9.png";